import * as React from "react";
const SvgFiRrAdPaid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ad-paid_svg__a)">
      <path
        fill="#062147"
        d="M6 4.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 6 4.5M8.5 3a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 3M24 5v3a1 1 0 0 1-1 1H2v8c0 1.654 1.346 3 3 3h8a1 1 0 0 1 0 2H5c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v2h20zm-8 7.3v3.4a2.3 2.3 0 0 1-2.3 2.3h-1.5a.8.8 0 0 1-.8-.8v-6.4a.8.8 0 0 1 .8-.8h1.5a2.3 2.3 0 0 1 2.3 2.3m-1.6 0a.7.7 0 0 0-.7-.7H11v4.802h.7a.7.7 0 0 0 .7-.7V12.3m-5.055-1.107 1.221 5.947a.716.716 0 0 1-.701.86h-.01a.716.716 0 0 1-.705-.591l-.157-.883H4.987l-.166.889a.716.716 0 1 1-1.406-.272l1.2-5.976C4.718 10.587 5.243 10 6 10s1.226.524 1.346 1.192zm-.729 3.808-.638-3.295-.624 3.295zm15.069 1.267-3.042-.507a.77.77 0 0 1-.644-.76c0-.551.449-1 1-1h2.268c.356 0 .688.192.867.5a.999.999 0 1 0 1.731-1.001 3.01 3.01 0 0 0-2.598-1.499h-.268v-1a1 1 0 0 0-2 0v1c-1.654 0-3 1.346-3 3 0 1.36.974 2.51 2.315 2.733l3.042.507a.77.77 0 0 1 .644.76c0 .551-.449 1-1 1h-2.268c-.356 0-.688-.192-.867-.5a1 1 0 0 0-1.366-.365 1 1 0 0 0-.365 1.366 3.01 3.01 0 0 0 2.598 1.499H19v1a1 1 0 0 0 2 0v-1c1.654 0 3-1.346 3-3 0-1.36-.974-2.51-2.315-2.733"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ad-paid_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAdPaid;
